var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wpcal-widget"}},[_c('div',{staticClass:"widget-main"},[_c('div',{staticStyle:{"padding":"20px","text-align":"center","width":"100%"}},[_vm._v(" "+_vm._s(_vm.__("No more bookings allowed.", "wpcal"))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }